import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../../../styles'
import classNames from 'classnames'
import Button from '../../../../../components/button/Button'
import { saveInteractions } from '../../../../gtm/utils/gtmCallback'
import portals from '../../../../../enums/portalsEnum'

const useStyle = makeStyles((theme) => ({
		...styles(theme),
		headerContainer: {
			justifyContent: 'space-between',
			alignItems: 'center',
			marginTop: '3%',
			backgroundColor: theme.palette.accessibility.main,
			marginRight: 0,
			marginLeft: 0
		},
		largeHeaderContainer: {
			padding: '3% 5%'
		},
		smallHeaderContainer: {
			padding: 16,
			margin: '21px 16px'
		},
		flexColumn: {
			display: 'flex',
			flexDirection: 'column'
		},
		subTitle: {
			marginLeft: '2%'
		},
		balanceDiv: {
			alignItems: 'center'
		},
		balanceDivLargeScreen: {
			justifyContent: 'flex-end'
		},
		smallBalanceDiv: {
			justifyContent: 'space-between'
		},
		removeFlexPadding: {
			paddingLeft: 0,
			paddingRight: 0
		},
		balanceTextLargeScreen: {
			textAlign: 'right',
			paddingRight: '7%'
		},
		balanceTextSmallScreen: {
			paddingTop: 17,
			paddingBottom: 17
		}
	}
))

interface AcceptingProps {
	solde: number,
	isLargeScreen: boolean,
	setOpenPayment: (value: boolean) => void,
	paymentDisabled: boolean
}

type AccountHeaderProps = AcceptingProps

const AccountHeader: React.FC<AccountHeaderProps> = (
	{
		solde,
		isLargeScreen,
		setOpenPayment,
		paymentDisabled
	}
) => {
	const classes = useStyle()
	const intl = useIntl()
	const headerTitle = classNames(
		classes.colorWhite,
		isLargeScreen ? classes.text0 : classes.text18
	)
	const headerSubTitle = classNames(
		classes.colorWhite,
		isLargeScreen ? classes.text1_opacity : classes.text3,
		{
			[classes.medium]: !isLargeScreen,
			[classes.subTitle]: isLargeScreen
		}
	)

	const headerContainerClass = classNames(
		'row',
		classes.headerContainer,
		isLargeScreen ? classes.largeHeaderContainer : classes.smallHeaderContainer
	)

	const headerTitleLeftClass = classNames(
		'col-xs-12 col-md-6',
		classes.removeFlexPadding,
		{
			[classes.flexColumn]: !isLargeScreen
		}
	)

	const balanceDivClass = classNames(
		'col-xs-12 col-md-6 row',
		classes.removeFlexPadding,
		classes.balanceDiv,
		isLargeScreen ? classes.balanceDivLargeScreen : classes.smallBalanceDiv
	)

	const balanceTextClass = classNames(
		isLargeScreen ? 'col-xs-6' : 'col-xs-9',
		isLargeScreen ? classes.balanceTextLargeScreen : classes.balanceTextSmallScreen
	)

	const getYesterdayDate = (separator = '') => {
		let newDate = new Date()
		newDate.setDate(newDate.getDate() - 1)
		const date = newDate.getDate()
		const month = newDate.getMonth() + 1
		const year = newDate.getFullYear()
		return `${date}${separator}${month < 10 ? `0${month}` : `${month}`}${separator}${year}`
	}

	return (
		<div className={headerContainerClass}>
			{process.env.REACT_APP_TARGET === portals.residence ?
				<>
					<div className={headerTitleLeftClass}>
						<span className={headerTitle}>
							<FormattedMessage
								id="contracts.account.balance"
								defaultMessage="Votre solde"
								description="Account balance"
							/>
						</span>
						<span className={headerSubTitle}>
							<FormattedMessage
								id="contracts.account.onDay"
								defaultMessage="au "
								description="Account onDay word"
							/>
							{getYesterdayDate('/')}
						</span>
					</div>
					<div className={balanceDivClass}>
						<div className={balanceTextClass}>
							<span className={headerTitle}>
								{`${solde.toLocaleString()} €`}
							</span>
						</div>
						{solde < 0 && <div>
							<Button
								background="backgroundWhite"
								color="colorAccessibility"
								textStyle="text8"
								disabled={paymentDisabled}
								onClick={() => {
									saveInteractions(
										{
											category: 'Votre Compte',
											action: 'Paiement en Ligne',
											label: 'Payer en ligne Solde'
										}
									)
									setOpenPayment(true)
								}}
								title={intl.formatMessage({
									id: 'contracts.account.payBalanceTitle',
									defaultMessage: 'Le solde de votre compte sera mis à jour 24 heures après votre règlement',
									description: 'Tooltip of the payment button'
								})}
							>
								<FormattedMessage
									id="contracts.account.payBalance"
									defaultMessage="Payer le solde"
									description="Payment button"
								/>
							</Button>
						</div>}
					</div>
				</>
				:
				<></>
			}
		</div>
	)
}

export default AccountHeader
